import React, { useRef, useEffect } from "react";

const RestrictCopyPaste = ({ children }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const handleCopy = (e) => {
      e.preventDefault();
      console.log("Copy action prevented");
    };

    const handleCut = (e) => {
      e.preventDefault();
      console.log("Cut action prevented");
    };

    const handlePaste = (e) => {
      e.preventDefault();
      console.log("Paste action prevented");
    };

    const handleSelectStart = (e) => {
      e.preventDefault();
      console.log("Text selection prevented");
    };

    const containerElement = containerRef.current;

    if (containerElement) {
      containerElement.addEventListener("copy", handleCopy);
      containerElement.addEventListener("cut", handleCut);
      containerElement.addEventListener("paste", handlePaste);
      containerElement.addEventListener("selectstart", handleSelectStart);
    }

    return () => {
      if (containerElement) {
        containerElement.removeEventListener("copy", handleCopy);
        containerElement.removeEventListener("cut", handleCut);
        containerElement.removeEventListener("paste", handlePaste);
        containerElement.removeEventListener("selectstart", handleSelectStart);
      }
    };
  }, []);

  return (
    <div ref={containerRef} style={{ userSelect: "none" }}>
      {children}
    </div>
  );
};

export default RestrictCopyPaste;
